import React, { createContext, useContext, useReducer } from "react";

// 1. Create the context
const EvaluationContext = createContext();

export const ageRangeOptions = [
  { value: "1", label: "Ages 18+" },
  { value: "2", label: "Ages 8-13" },
  { value: "3", label: "Ages 14-17" },
];
export const sportSeasonOptions = [
  { value: "0", label: "Summer" },
  { value: "1", label: "Fall" },
  { value: "2", label: "Winter" },
  { value: "3", label: "Spring" },
];
export const genderOptions = [
  { value: "1", label: "Female" },
  { value: "2", label: "Male" },
  { value: "3", label: "Non-binary" },
  { value: "4", label: "Transgender" },
  { value: "5", label: "Intersex" },
  { value: "6", label: "Prefer Not To Say" },
  { value: "7", label: "Other" },
];
export const athleteLevelOptions = [
  { value: "1", label: "Beginner" },
  { value: "2", label: "Intermediate" },
  { value: "3", label: "Advanced" },
  { value: "4", label: "Professional" },
];

export const QuestionTypes= [
  "Wellness",
  "Concern",
  "Abuse",
]

export const initialState = {
  session: {
    id: "",
    questions: {},
    questionsById: {},
    answers: {},   
    currentQuestion: null,
    currentQuestionType: 0,
    numSequences: 0,
    startSequence: -1,
    endSequence: -1,
    currentSequence: 0,
    progress: 0,
  },
  evaluation: {},
  demographics: {
    ageRangeOptions: ageRangeOptions,
    sportSeasonOptions: sportSeasonOptions,
    genderOptions: genderOptions,
    athleteLevelOptions: athleteLevelOptions,
    ageRange: "",
    sportSeason: "",
    gender: "",
    athleteLevel: ""
  }
};

const evalDataReducer = (state, action) => {
  switch (action.type) {
    case "SET_ANSWER":
      return { 
        ...state,
        session: {
          ...state.session,
          answers: {
            ...state.session.answers,
            [action.questionId]: { ...action.answer }
          }
        }
      };
    case "START_SESSION":
      return { 
        ...state,
        session: {
          ...initialState.session,
          id: action.sessionId,
        }
      };
    case "RECEIVE_QUESTIONS":
      const startSequence = action.startSequence || 0;
      const endSequence = action.endSequence || Object.keys(action.questions).length - 1;
      const startQuestionType = 'Wellness';
      const startQuestion = action.questions[startSequence][startQuestionType];
      startQuestion.index = 0;
      return { 
        ...state,
        session: {
          ...state.session,
          questions: action.questions,
          questionsById: action.questionsById,
          numSequences: action.numSequences,
          startSequence: startSequence,
          endSequence: endSequence,
          currentQuestion: startQuestion,
          currentSequence: startSequence,
          currentQuestionType: QuestionTypes.indexOf(startQuestionType),
        }
      };
    case "SET_CURRENT_QUESTION":  
      return {
        ...state,
        session: {
          ...state.session,
          currentQuestion: action.question,
          currentQuestionType: action.questionType || QuestionTypes.indexOf('Wellness'),
          currentSequence: action.sequence || state.session.currentSequence,
          progress: action.progress || state.session.progress,
        },
      };      
    case "SET_EVALUATION":
      return { 
        ...state, 
        evaluation: {
          ...action.evaluation,
          slug: action.slug,
        }
      };
    case "SET_DEMOGRAPHICS":
      return { ...state, 
        demographics: {
          ...state.demographics,
          ...action.ageRange,
          ...action.sportSeason,
          ...action.gender,
          ...action.athleteLevel
        }
      };
    case "SET_DEMOGRAPHSIC_FIELD":
      return {
        ...state,
        demographics: {
          ...state.demographics,
          [action.field]: action.value
        }
      };
    case "SET_PROGRESS":
      return {
        ...state,
        session: { 
          ...state.session,
          progress: action.progress
        }
      };
    case "LOAD_CACHED":
      return { ...state, ...action.payload };
    default:
      return state;
  } 
};

// 2. Create a provider component
export function EvaluationProvider({ children, initial }) {
  const [evalData, dispatch] = 
      useReducer(evalDataReducer,  initial || initialState);

  //   // TODO Save to localStorage whenever evalData changes
  // useEffect(() => {
  //   localStorage.setItem("evalData", JSON.stringify(evalData));
  // }, [evalData]);

  // // Load from localStorage on mount
  // useEffect(() => {
  //   const cached = localStorage.getItem("evalData");
  //   if (cached) {
  //     dispatch({ type: "LOAD_CACHED", payload: JSON.parse(cached) });
  //   }
  // }, []);

  return (
    <EvaluationContext.Provider value={{ evalData, dispatch  }}>
      {children}
    </EvaluationContext.Provider>
  );
}

// 3. Create a custom hook for easy access
export function useEvaluationData() {
  return useContext(EvaluationContext);
}